export default "__VITE_ASSET__BQ3tFfV3__"